import { render, staticRenderFns } from "./ProductComposition.vue?vue&type=template&id=8ec8f688&scoped=true"
import script from "./ProductComposition.vue?vue&type=script&lang=ts"
export * from "./ProductComposition.vue?vue&type=script&lang=ts"
import style0 from "./ProductComposition.vue?vue&type=style&index=0&id=8ec8f688&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec8f688",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ec8f688')) {
      api.createRecord('8ec8f688', component.options)
    } else {
      api.reload('8ec8f688', component.options)
    }
    module.hot.accept("./ProductComposition.vue?vue&type=template&id=8ec8f688&scoped=true", function () {
      api.rerender('8ec8f688', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/products/ProductComposition.vue"
export default component.exports